import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import ReadingCalculator from "@/features/reading-calculator/components/reading-calculator"

Vue.use(VueI18n)

const container = document.querySelector(".vue-reading-calculator")

if (container) {
  const { headline, usp } = container.dataset

  new Vue({
    name: "ReadingCalculatorInit",
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(ReadingCalculator, {
        props: {
          headline,
          usp
        }
      })
  })
}
